export const teamReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_TEAM_MEMBERS_LIST_REQUEST":
      return {
        loading: true,
        teamMembers: null,
      };
    case "GET_TEAM_MEMBERS_LIST_SUCCESS":
      return {
        loading: false,
        teamMembers: action.payload,
      };
    case "GET_TEAM_MEMBERS_LIST_FAILED":
      return {
        loading: false,
        teamMembers: action.payload,
      };
    
    case "ADD_MEMBER_REQUEST":
      return {
        loading: true,
        teamMembers: null,
      };
    case "ADD_MEMBER_SUCCESS":
      return {
        loading: false,
        teamMembers: action.payload,
      };
    case "ADD_MEMBER_FAILED":
      return {
        loading: false,
        teamMembers: action.payload,
      };

    case "BLOCK_UNBLOCK_MEMBER_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "BLOCK_UNBLOCK_MEMBER_SUCCESS":
      return {
        ...state,
        loading: false,
        teamMembers: action.payload,
      };
    case "BLOCK_UNBLOCK_MEMBER_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "UPDATE_MEMBER_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "UPDATE_MEMBER_SUCCESS":
      return {
        ...state,
        loading: false,
        teamMembers: action.payload,
      };
    case "UPDATE_MEMBER_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "VIEW_MEMBER_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "VIEW_MEMBER_SUCCESS":
      return {
        ...state,
        loading: false,
        selectedMember: action.payload,  
      };
    case "VIEW_MEMBER_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
